import { WidgetHelper } from '@/helpers/Widget'
import VitalPreviewWidget from '@/modules/VitalPreviewWidget/components/VitalPreviewWidget.vue'

WidgetHelper.registerContinuously(VitalPreviewWidget, '.sanitasOvpVitalPreview')
